import React, { useEffect, useState } from 'react';
import api from '../../api/axios';
import { useTranslation } from 'react-i18next';

const AdminIPCheck = () => {
  const { t } = useTranslation();

  const [enabled, setEnabled] = useState(false);
  const [allowedCountries, setAllowedCountries] = useState<string[]>([]);
  const [loading, setLoading] = useState(true);

  const countryList = [
    { code: 'JP', name: 'Japan' },
    { code: 'CN', name: 'China' },
    { code: 'HK', name: 'Hong Kong' },
    { code: 'TW', name: 'Taiwan' },
    { code: 'KR', name: 'South Korea' },
    { code: 'TH', name: 'Thailand' },
    { code: 'VN', name: 'Vietnam' },
    { code: 'SG', name: 'Singapore' },
    { code: 'MY', name: 'Malaysia' },
    { code: 'PH', name: 'Philippines' },
    { code: 'ID', name: 'Indonesia' },
    { code: 'US', name: 'United States' },
    { code: 'CA', name: 'Canada' },
    { code: 'IN', name: 'India' },
    { code: 'AU', name: 'Australia' },
    { code: 'DE', name: 'Germany' },
    { code: 'FR', name: 'France' },
    { code: 'GB', name: 'United Kingdom' },
  ];

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const res = await api.get('/check-ip/settings');
        setEnabled(res.data.enabled);
        setAllowedCountries(res.data.allowed_countries);
      } catch (err) {
        console.error('Failed to fetch IP settings:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchSettings();
  }, []);

  const handleSave = async () => {
    try {
      await api.post('/check-ip/settings', {
        enabled,
        allowed_countries: allowedCountries,
      });
      alert(t('admin.ipcheck_saved'));
    } catch (err) {
      alert(t('admin.ipcheck_save_failed'));
      console.error(err);
    }
  };

  const handleToggleCountry = (code: string) => {
    setAllowedCountries((prev) =>
      prev.includes(code)
        ? prev.filter((c) => c !== code)
        : [...prev, code]
    );
  };

  if (loading) return <div className="p-4">Loading...</div>;

  return (
    <div className="w-full max-w-3xl mx-auto p-4">
      <h2 className="text-2xl font-bold mb-4">{t('admin.ipcheck_title')}</h2>

      <div className="bg-white shadow rounded-xl p-4 space-y-4">
        <div>
          <label className="flex items-center gap-2">
            <input
              type="checkbox"
              checked={enabled}
              onChange={(e) => setEnabled(e.target.checked)}
              className="w-5 h-5"
            />
            <span className="text-lg font-medium">{t('admin.ipcheck_enable')}</span>
          </label>
          <p className="text-sm text-gray-500">{t('admin.ipcheck_description')}</p>
        </div>

        <div>
          <h3 className="text-md font-semibold mb-2">{t('admin.ipcheck_select_countries')}</h3>
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-2">
            {countryList.map((country) => (
              <label key={country.code} className="flex items-center gap-2 text-sm">
                <input
                  type="checkbox"
                  checked={allowedCountries.includes(country.code)}
                  onChange={() => handleToggleCountry(country.code)}
                />
                {country.name}
              </label>
            ))}
          </div>
        </div>

        <div className="pt-4">
          <button
            onClick={handleSave}
            className="bg-coral text-white px-4 py-2 rounded hover:opacity-90 transition"
          >
            {t('admin.save_button')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AdminIPCheck;
